export default {
    riskAssessment: {
        popupAttributeKeys: ["km", "zone_id", "type", "p75", "p75_weight"],
        zonesListAttributeKeys: [{
            title: "Topographic zone defined by road segment",
            keys: ["km", "zone_id", "type"]
        }, {
            title: "Exposure to slope deformation annual rates",
            subtitle: "(zonal statistics)",
            keys: ["min", "p25", "median", "mean", "p75", "p75_weight", "max", "count", "p75_dts"]
        }, {
            title: "Exposure to hazard classes",
            subtitle: "(zonal frequency)",
            keys: ["haz_0_10", "haz_10_20", "haz_20_30", "haz_30_40", "haz_40_50", "haz_50_"]
        }, {
            title: "Interferometric reliability",
            subtitle: "(zonal frequency)",
            keys: ["A", "B", "C", "D"]
        }, {
            title: "Inventoried landslides",
            subtitle: "(zonal frequency)",
            keys: ["ls_freq"]
        }, {
            title: "Landslide susceptibility",
            subtitle: "(zonal statistics)",
            keys: ["susc_mean", "susc_p83", "susc_m_std", "susc_m_rng"]
        }],
        roadsListAttributeKeys: [{
            title: "Road",
            keys: ["km", "zone_id", "p75_weight"]
        }]
    },
    interferometry: {
        fidColumnName: "id",
        popupAttributeKeys: ["id", "vel_avg", "coh_mod", "rel_cm", "orbit"],
        listAttributeKeys: [{
            keys: ["id"]
        },{
            title: "PSI estimations",
            keys: ["vel_avg", "vel_cum", "cl_prg", "cl_dyn"]
        },{
            title: "PSI reliability",
            keys: ["coh", "vel_sd", "s0", "sens", "rel_cm", "val_rank"]
        },{
            title: "Metadata",
            keys: ["rel_track", "orbit", "inc_ang", "az_ang", "method", "aspect", "slope"]
        }],
        tracks: {
            types: {
                keys: ["los", "dts"],
                activeKey: "los"
            },
            orbits: {
                keys: ["ascending", "descending"],
                activeKeys: ["descending"],
                lastInteractedTrackKey: null,
                trackByKey: {
                    ascending: ["t143", "t41"],
                    descending: ["t4"]
                }
            }
        }
    },
    layerOrder: {
        "interferometry-big": ["interferometry-zones-big","interferometry-roads-big", "interferometry-points-big"],
        "interferometry-small": ["interferometry-zones-small","interferometry-roads-small", "interferometry-points-small"],
        "risk-assessment-big": ["risk-assessment-zones-big","risk-assessment-roads-big"],
        "risk-assessment-small": ["risk-assessment-zones-small","risk-assessment-roads-small"]
    },
    layerStyles: {
        "risk-assessment-zones-big": {
            active: "riskAssessmentZonesP75Big",
            available: ["riskAssessmentZonesP75Big", "riskAssessmentZonesP75DtsBig", "riskAssessmentZonesLandslidesBig", "riskAssessmentZonesSusceptibilityBig"]
        },
        "risk-assessment-roads-big": {
            active: "riskAssessmentRoadsP75Big",
            available: ["riskAssessmentRoadsP75Big"]
        },
        "interferometry-points-big": {
            active: "interferometryPointsDisplacementBig",
            available: ["interferometryPointsDisplacementBig"]
        },
        "interferometry-zones-big": {
            active: "interferometryZonesBig",
            available: ["interferometryZonesBig"]
        },
        "interferometry-roads-big": {
            active: null,
            available: ["riskAssessmentRoadsP75Big"]
        },
    },
    bigSmallMapPairs: {
        maps: {
            "risk-assessment-big": "risk-assessment-small",
            "interferometry-big": "interferometry-small"
        },
        layers: {
            "risk-assessment-zones-big": "risk-assessment-zones-small",
            "risk-assessment-roads-big": "risk-assessment-roads-small",
            "interferometry-points-big": "interferometry-points-small",
            "interferometry-zones-big": "interferometry-zones-small",
            "interferometry-roads-big": "interferometry-roads-small"
        },
        styles: {
            "riskAssessmentZonesP75Big": "riskAssessmentZonesP75Small",
            "riskAssessmentZonesP75DtsBig": "riskAssessmentZonesP75DtsSmall",
            "riskAssessmentRoadsP75Big": "riskAssessmentRoadsP75Small",

            "riskAssessmentZonesLandslidesBig": "riskAssessmentZonesLandslidesSmall",
            "riskAssessmentZonesSusceptibilityBig": "riskAssessmentZonesSusceptibilitySmall",

            "interferometryPointsDisplacementBig": "interferometryPointsDisplacementSmall",
            "interferometryZonesBig": "interferometryZonesSmall"
        }
    },
    activeViewKey: "f0217d4c-60dd-4416-91f2-67f2e7f1426c"
}